<template>
  <div class="dot-pulse-loader">
    <div
      :class="color ? 'dot-pulse-custom' : 'dot-pulse'"
      :style="color ? { '--dot-color': color } : {}"
    ></div>
  </div>
</template>

<script lang="ts">
export default {
  name: "DotPulseLoader",
  props: {
    // Optional color (CSS color string). When provided, overrides default via CSS var.
    color: {
      default: undefined,
      type: String,
    },
  },
};
</script>

<style scoped>
/* Import the dot-pulse styles - adjust path as needed */
@import "./dot-pulse.css";

.dot-pulse-loader {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 20px;
  min-width: 60px;
}
</style>
